import { Component } from '@angular/core';
import { TitleCardModel } from '../../../../models/title-card.model';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrl: './team.component.scss',
  standalone: false,
})
export class TeamComponent {
  public titleCard: TitleCardModel = {
    image: '../../../assets/images/placeholder.svg',
  };
}
